


import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    useTable,
    useSortBy,
    useGlobalFilter,
    usePagination,
    useFilters,
} from "react-table";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
// import "../../assets/fonts/IRANSans-normal"; // مسیر درست به فایل js
import { addIranSansFont } from "../../../../../assets/fonts/IRANSans-normal"
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

import moment from "jalali-moment";
import { Calendar } from "@hassanmojab/react-modern-calendar-datepicker";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import { FaCircle, FaFileExcel, FaFilePdf, FaSearch } from "react-icons/fa";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import DateRangeFilterBox from '../../../../user/subscription/userPlansList/components/DateRangeFilterBox'
import '../../../../../assets/fonts/Vazir-normal'
const PlansListTable = ({ userPlanList: data }) => {
    const [selectedMinDate, setSelectedMinDate] = useState(null);
    const [selectedMaxDate, setSelectedMaxDate] = useState(null);
    const [globalFilter, setGlobalFilter] = useState("");
    const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [selectedStatus, setSelectedStatus] = useState('فیلتر بر اساس وضعیت')
    const [selectedDateField, setSelectedDateField] = useState("createdAt");

    const handleClearDateFilters = () => {
        setSelectedMinDate(null);
        setSelectedMaxDate(null);
        setSelectedDateField("createdAt");
    };
    const sortedData = useMemo(() => {
        return [...data].sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
    }, [data]);
    const columns = useMemo(
        () => [
            {
                Header: "#",
                Cell: ({ row }) => row.index + 1,
                disableSortBy: true,
            },
            {
                Header: "نام طرح",
                accessor: (row) => row.plan?.name,
            },
            {
                Header: "نام بات",
                accessor: (row) => row.business?.username,
            },

            {
                Header: "توکن‌های باقی مانده",
                accessor: (row) => row?.remainingTokens.toLocaleString('fa-IR'),
            },
            {
                Header: "تاریخ ثبت",
                accessor: "createdAt",
                Cell: ({ value }) =>moment.utc(value)
                .local()
                .locale('fa')
                .format("jYYYY/jMM/jDD HH:mm")
                    //  moment(value).format("jYYYY/jMM/jDD HH:mm"),
            },
            {
                Header: "تاریخ انقضا",
                accessor: "endDate",
                Cell: ({ value }) => value == null ? "نامحدود" : 
                moment.utc(value)
                .local()
                .locale('fa')
                .format("jYYYY/jMM/jDD HH:mm")
                // moment(value).format("jYYYY/jMM/jDD HH:mm"),
            },
            {
                Header: "کد تراکنش",
                accessor: "transactionId",
            },
            {
                Header: "وضعیت",
                accessor: "isActive",
                Cell: ({ value }) => (

                    <FaCircle className={`text-sm text-center mx-auto ${value ? "text-green-500" : "text-red-500"}`} />

                ),
            },

        ],
        []
    );
    useEffect(() => {
        if (selectedMinDate) {
            const m = moment
                .from(
                    `${selectedMinDate.year}/${selectedMinDate.month}/${selectedMinDate.day}`,
                    "fa",
                    "YYYY/MM/DD"
                )
                .startOf("day");
            setMinDate(m.toISOString());
        } else {
            setMinDate("");
        }

        if (selectedMaxDate) {
            const m = moment
                .from(
                    `${selectedMaxDate.year}/${selectedMaxDate.month}/${selectedMaxDate.day}`,
                    "fa",
                    "YYYY/MM/DD"
                )
                .endOf("day");
            setMaxDate(m.toISOString());
        } else {
            setMaxDate("");
        }
    }, [selectedMinDate, selectedMaxDate]);
    // const filteredData = useMemo(() => {
    //     if (!Array.isArray(sortedData)) return [];

    //     return sortedData.filter((item) => {
    //         const createdAt = item.createdAt ? moment(item.createdAt) : null;

    //         const matchesDate =
    //             (!minDate || (createdAt && createdAt.isSameOrAfter(moment(minDate)))) &&
    //             (!maxDate || (createdAt && createdAt.isSameOrBefore(moment(maxDate))));

    //         const matchesName =
    //             item?.plan?.name?.toLowerCase()?.includes(globalFilter?.toLowerCase()) ||
    //             item?.businessId?.toLowerCase()?.includes(globalFilter?.toLowerCase());


    //         const matchesStatus =
    //             statusFilter === "" ||
    //             (statusFilter === "true" && item.isActive === true) ||
    //             (statusFilter === "false" && item.isActive === false);

    //         return matchesName && matchesDate && matchesStatus;
    //     });
    // }, [sortedData, globalFilter, minDate, maxDate, statusFilter]);
    const filteredData = useMemo(() => {
        if (!Array.isArray(sortedData)) return [];

        return sortedData.filter((item) => {
            const dateFieldValue = item[selectedDateField] ? moment(item[selectedDateField]) : null;

            const matchesDate =
                (!minDate || (dateFieldValue && dateFieldValue.isSameOrAfter(moment(minDate)))) &&
                (!maxDate || (dateFieldValue && dateFieldValue.isSameOrBefore(moment(maxDate))));

            const matchesName =
                item?.plan?.name?.toLowerCase()?.includes(globalFilter?.toLowerCase()) ||
                item?.businessId?.toLowerCase()?.includes(globalFilter?.toLowerCase()) ||
                item?.transactionId?.toLowerCase()?.includes(globalFilter?.toLowerCase())||
                item?.business?.username?.toLowerCase()?.includes(globalFilter?.toLowerCase());
            const matchesStatus =
                statusFilter === "" ||
                (statusFilter === "true" && item.isActive === true) ||
                (statusFilter === "false" && item.isActive === false);

            return matchesName && matchesDate && matchesStatus;
        });
    }, [sortedData, globalFilter, minDate, maxDate, statusFilter, selectedDateField]);

    const tableInstance = useTable(
        {
            columns,
            data: filteredData,
            initialState: { pageSize: 5 },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = tableInstance;
    
    const exportToExcel = () => {
        const mappedData = filteredData.map((item) => ({
            "نام طرح": item.plan.name,
            "توکن باقی‌مانده": Number(item.remainingTokens).toLocaleString("en-US"),
            "تاریخ ثبت": moment.utc(item.createdAt)
            .local()
            .locale('fa')
            .format("jYYYY/jMM/jDD HH:mm"),
            // moment(item.createdAt).format("jYYYY/jMM/jDD HH:mm"),
            "تاریخ انقضا": item.endDate == null ? "نامحدود" :
            //  moment(item.endDate).format("jYYYY/jMM/jDD HH:mm")
            moment.utc(item.endDate)
            .local()
            .locale('fa')
            .format("jYYYY/jMM/jDD HH:mm")
             ,
            "کد تراکنش": item.transactionId,
        }));
    
        const ws = XLSX.utils.json_to_sheet(mappedData, { origin: "A2" });
    
        // اضافه کردن تیتر بالای جدول
        XLSX.utils.sheet_add_aoa(ws, [["لیست پلن‌های کاربران"]], { origin: "A1" });
    
        // Merge تیتر روی ۵ ستون
        ws["!merges"] = [
            {
                s: { r: 0, c: 0 },
                e: { r: 0, c: 4 },
            },
        ];
    
        // تنظیم عرض ستون‌ها
        ws["!cols"] = [
            { wch: 25 },
            { wch: 20 },
            { wch: 25 },
            { wch: 25 },
            { wch: 25 },
        ];
    
        //  راست‌چین کردن همه‌ی سلول‌های داده‌ها
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = { c: C, r: R };
                const cellRef = XLSX.utils.encode_cell(cellAddress);
                if (!ws[cellRef]) continue;
                if (!ws[cellRef].s) ws[cellRef].s = {};
                ws[cellRef].s.alignment = { horizontal: "right" };
            }
        }
    
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "planList");
    
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array", cellStyles: true });
        const dataBlob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(dataBlob, "planList.xlsx");
    };
    

    addIranSansFont(jsPDF);
    const exportToPDF = () => {
        const doc = new jsPDF();

        // doc.addFileToVFS("Vazir.ttf", vazirFont);
        // doc.addFont("Vazir.ttf", "Vazir", "normal");
        doc.setFont("Vazir")
        const tableColumn = [
            "نام طرح",
            "توکن باقی‌مانده",
            "تاریخ ثبت",
            "تاریخ انقضا",
            "کد تراکنش",
        ];
        const tableRows = filteredData.map((item) => [
            item.plan.name,
            item.remainingTokens,
            moment.utc(item.createdAt)
            .local()
            .locale('fa')
            .format("jYYYY/jMM/jDD HH:mm"),
            item.endDate==null?"نامحدود": moment.utc(item.endDate)
            .local()
            .locale('fa')
            .format("jYYYY/jMM/jDD HH:mm"),
            item.transactionId,
        ]);

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            styles: {
                font: "Vazir",
                fontStyle: "normal",
                halign: "center",
            },
            headStyles: {
                halign: "center",
            },
        });
        doc.save("planList.pdf");
    };

    const resetFilters = () => {
        setGlobalFilter("");
        setStatusFilter("");
        setSelectedStatus('فیلتر بر اساس وضعیت')
        setSelectedMinDate(null);
        setSelectedMaxDate(null);
    };

    return (
        <div className="p-4  max-w-5xl mx-auto">
            <div className="space-y-4 mb-5 mt-10">

                <div className="flex flex-wrap gap-4 items-center">
                    <label htmlFor="search" className="text-gray-700 font-semibold text-lg">
                        جستجو
                    </label>
                    <div className="relative w-full md:w-1/2">
                        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                        <input
                            id="search"
                            value={globalFilter}
                            onChange={(e) => setGlobalFilter(e.target.value)}
                            placeholder="جستجوی نام طرح،کد تراکنش،نام بات،..."
                            className="border rounded px-4 py-2 pl-10 w-full text-sm focus:border-[#aadec5] focus:outline-none focus:ring-2 focus:ring-[#aadec5]"
                        />
                    </div>
                </div>

                {/* سطر دوم: فیلترها و دکمه‌ها */}
                <div className="flex flex-wrap gap-8 items-end flex-grow">
                    <div className="flex flex-wrap sm:flex-nowrap gap-4">

                        <div className="flex flex-col">
                            <Menu as="div" className="relative inline-block text-left w-[200px]">
                                <div>
                                    <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50">
                                        {selectedStatus}
                                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                                    </Menu.Button>
                                </div>

                                <Menu.Items
                                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                                >
                                    <div className="py-1">
                                        <Menu.Item>
                                            {({ active }) => (
                                                <a
                                                    href="#"
                                                    onClick={() => {
                                                        setSelectedStatus('فیلتر بر اساس وضعیت');
                                                        setStatusFilter("");
                                                    }}
                                                    className={`block px-4 py-2 text-center text-sm text-gray-700 ${active ? 'bg-gray-100 text-gray-900' : ''
                                                        }`}
                                                >
                                                    همه وضعیت‌ها
                                                </a>
                                            )}
                                        </Menu.Item>

                                        <Menu.Item>
                                            {({ active }) => (
                                                <a
                                                    href="#"
                                                    onClick={() => {
                                                        setSelectedStatus('فعال');
                                                        setStatusFilter("true");
                                                    }}

                                                    className={`block px-4 py-2 text-center text-sm text-gray-700 ${active ? 'bg-gray-100 text-gray-900' : ''}`}
                                                >
                                                    فعال
                                                </a>
                                            )}
                                        </Menu.Item>
                                        <Menu.Item>
                                            {({ active }) => (
                                                <a
                                                    href="#"
                                                    onClick={() => {
                                                        setSelectedStatus('غیرفعال');
                                                        setStatusFilter("false");
                                                    }}

                                                    className={`block px-4 py-2 text-center text-sm text-gray-700 ${active ? 'bg-gray-100 text-gray-900' : ''}`}
                                                >
                                                    غیرفعال
                                                </a>
                                            )}
                                        </Menu.Item>
                                    </div>
                                </Menu.Items>
                            </Menu>
                        </div>

                    </div>

                    <div className="flex flex-wrap sm:flex-nowrap gap-4">

                        {/* تاریخ‌ها */}

                        <DateRangeFilterBox
                            selectedMinDate={selectedMinDate}
                            selectedMaxDate={selectedMaxDate}
                            setSelectedMinDate={setSelectedMinDate}
                            setSelectedMaxDate={setSelectedMaxDate}
                            selectedDateField={selectedDateField}
                            setSelectedDateField={setSelectedDateField}
                            onClearFilters={handleClearDateFilters}
                        />


                        {/* <DateRangeFilterBox
                            selectedMinDate={selectedMinDate}
                            selectedMaxDate={selectedMaxDate}
                            setSelectedMinDate={setSelectedMinDate}
                            setSelectedMaxDate={setSelectedMaxDate}
                        /> */}
                        {/* <CalendarInput
                            label="از تاریخ"
                            value={selectedMinDate}
                            onChange={setSelectedMinDate}
                        />
                        <CalendarInput
                            label="تا تاریخ"
                            value={selectedMaxDate}
                            onChange={setSelectedMaxDate}
                        /> */}
                    </div>
                    {/* دکمه‌ها */}
                    <button
                        onClick={resetFilters}
                        className="bg-yellow-400 px-4 py-2 rounded text-white h-9 mr-auto"
                    >
                        حذف فیلترها
                    </button>

                </div>

            </div>



            <div className="overflow-x-auto">
                <table {...getTableProps()} className="min-w-full bg-white border border-gray-300  rounded-xl shadow-md text-sm sm:text-base">
                    <thead className="bg-gray-100">
                        {headerGroups.map((headerGroup, index) => (
                            <tr key={headerGroup.name} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th
                                        key={column.id}
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                        className="text-center px-3  py-2 border-b border-gray-300 cursor-pointer whitespace-nowrap"
                                    >
                                        {column.render("Header")}
                                        <span>
                                            {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {page.length === 0 && (
                            <tr>
                                <td colSpan={columns.length} className="text-center py-4 text-gray-500">
                                    موردی برای نمایش وجود ندارد.
                                </td>
                            </tr>
                        )}
                        {page.map((row, index) => {
                            prepareRow(row);
                            return (
                                <tr 
                                // key={row.id || row.original.id}
                                key={index} {...row.getRowProps()}>
                                    {row.cells.map((cell) => (
                                        <td key={cell.column.id} {...cell.getCellProps()} className="px-3 py-2 border-b text-center">
                                            {cell.render("Cell")}
                                        </td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <div className="flex flex-wrap gap-2 items-end justify-end mt-5">
                <button onClick={exportToExcel} className="bg-green-500 px-4 py-2 rounded text-white">
                    <FaFileExcel />
                </button>
                <button onClick={exportToPDF} className="bg-red-500 px-4 py-2 rounded text-white">
                    <FaFilePdf />
                </button>

            </div>
            <div className="flex items-center justify-between mt-4">
                <div className="flex items-center gap-2">
                    <span>تعداد ردیف در صفحه:</span>
                    <select
                        value={pageSize}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                        className="border rounded  py-2"
                    >
                        {[5, 10, 20].map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="flex gap-2">
                    <button
                        onClick={previousPage}
                        disabled={!canPreviousPage}
                        className="px-4 py-2 border rounded disabled:opacity-50"
                    >
                        قبلی
                    </button>
                    <button
                        onClick={nextPage}
                        disabled={!canNextPage}
                        className="px-4 py-2 border rounded disabled:opacity-50"
                    >
                        بعدی
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PlansListTable;
